import useMetadata from "./useMetadata";

const useShopTheme = () => {
	const metadata = useMetadata();

	const { shop_theme: shopTheme } = metadata || {};
	let isConfigured = true;
	if (!shopTheme?.backgroundColor || !shopTheme?.foregroundColor)
		isConfigured = false;

	return {
		...shopTheme,
		isConfigured,
	};
};

export default useShopTheme;
